import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

export interface Result {
  data: number;
}

/**
 * Возвращает стоимость доставки
 */
async function getDeliveryCost<T>(body: T) {
  const url = `/shipping/api/get-cost`;
  const res = await Api.queryProxi<Result>(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!res.data) throw new BackendError(url, res);

  return res.data;
}

export default getDeliveryCost;
